import React from 'react'
import CustomerContainer from '../../../../../Components/UserPart/UserList/CustomerContainer/CustomerContainer'
import Layout from '../../../Layout'

const Customer = () => {
  return (
    <Layout>
        <CustomerContainer/>
    </Layout>
  )
}

export default Customer